import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Button, Card, CardContent, Typography } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { withRouter } from "react-router";

const SettingList = (props) => {
  const { settings } = props;

  const columns = [
    { field: "id", headerName: "#", width: 70 },
    { field: "name_persian", headerName: "نام مقدار", width: 130 },
    { field: "name", headerName: "نام", width: 130 },
    { field: "value", headerName: "مقدار", width: 130 },
    {
      field: "actions",
      headerName: "عملیات",
      width: 130,
      renderCell: (params) => {
        return (
          <strong>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginLeft: 16 }}
              onClick={(e) =>
                props.history.push("/settings/edit/" + params.row.id)
              }
            >
              ویرایش
            </Button>
          </strong>
        );
      },
    },
  ];

  const rows = settings;

  return (
    <Wrapper>
      <Card>
        <CardContent>
          <Box style={{ width: "100%", textAlign: "right" }} p={2}>
            <Typography variant={"body1"}>{props.title}</Typography>
          </Box>
          <div style={{ height: "400px", width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
              disableColumnFilter
              disableColumnMenu={true}
            />
          </div>
        </CardContent>
      </Card>
    </Wrapper>
  );
};

export default withRouter(SettingList);
